<template>

    <Page>

        <ImageAndText 
            src="/SuccessLeavesATrail/buyer-interest.png"
            animation="slide-up"
            floor-shadow
            border>

            <h2 class="mb-4">Consumers happy with health monitoring, not tracking</h2>
            <p class="font-normal text-white/80">
                73% Auto buyers want access to active health monitoring
                and agree that vehicle manufacturers and their purchasing dealers
                should have access to their telematics data to provide
                vehicle health services.
            </p>

        </ImageAndText>

        <div class="hidden lg:block absolute bottom-32 translate-x-32 text-white px-2 rounded shadow bg-[#a52c40]">
            * Based on 2023 Urban Science Report
        </div>

    </Page>

</template>